import { Navigate, useLocation } from 'react-router-dom'
import { authStore } from '@/store/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'admin' | 'user'
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user } = authStore()
  const location = useLocation()

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }

  if (requiredRole && user.role !== requiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF1DD] p-6">
        <div className="max-w-md w-full rounded-2xl border border-black/10 bg-white p-8 shadow-sm text-center">
          <h1 className="text-lg font-semibold text-gray-900 mb-2">Access denied</h1>
          <p className="text-sm text-gray-600 mb-4">
            You need the <strong>{requiredRole}</strong> role to view this page.
          </p>
          <a
            href="/dashboard"
            className="inline-flex items-center justify-center rounded-full bg-[#987628] px-5 py-2 text-sm font-medium text-white hover:bg-[#7a5f20]"
          >
            Back to dashboard
          </a>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
